<template>
  <div class="Maps">
    <v-content>
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-flex xs9>
            <vl-map
              class="map"
              ref="map"
              :load-tiles-while-animating="true"
              :load-tiles-while-interacting="true"
              data-projection="EPSG:4326"
              style="height: 600px"
              @mounted="onMapMounted"
              @click="onMapClick"
             >
              <vl-view
                :center.sync="mapViewConf.center"
                :zoom.sync="mapViewConf.zoom"
                :min-zoom.sync="mapViewConf.minZoom"
                :max-zoom.sync="mapViewConf.maxZoom"
                :rotation.sync="mapViewConf.rotation"
              ></vl-view>

              <!-- interactions -->
              <vl-interaction-select
                :features.sync="selectedFeatures"
              >
                <!-- <template slot-scope="select"> -->
                <template>
                  <!-- select styles -->
                  <vl-style-box>
                    <vl-style-stroke color="#e30613" :width="3"></vl-style-stroke>
                    <vl-style-fill :color="[232, 107, 0, 0.45]"></vl-style-fill>
                  </vl-style-box>
                  <!--// select styles -->

                  <!-- selected feature popup -->
                  <!-- <vl-overlay
                    class="feature-popup"
                    v-for="feature in select.features"
                    :key="feature.id"
                    :id="feature.id"
                    :position="pointOnSurface(feature.geometry)"
                    :auto-pan="true"
                    :auto-pan-animation="{ duration: 300 }"
                  >
                    <template slot-scope="popup">
                      <section class="card">
                        <header class="card-header">
                          <p class="card-header-title">
                            Feature ID {{ feature.id }}
                          </p>
                          <a class="card-header-icon" title="Close"
                             @click="selectedFeatures = selectedFeatures.filter(f => f.id !== feature.id)">
                            <b-icon icon="close"></b-icon>
                          </a>
                        </header>
                        <div class="card-content">
                          <div class="content">
                            <p>
                              Overlay popup content for Feature with ID <strong>{{ feature.id }}</strong>
                            </p>
                            <p>
                              Popup: {{ JSON.stringify(popup) }}
                            </p>
                            <p>
                              Feature: {{ JSON.stringify({ id: feature.id, properties: feature.properties }) }}
                            </p>
                          </div>
                        </div>
                      </section>
                    </template>
                  </vl-overlay> -->
                  <!--// selected popup -->
                </template>
              </vl-interaction-select>
              <!--// interactions -->

              <vl-layer-tile id="osm">
                <vl-source-osm></vl-source-osm>
              </vl-layer-tile>

              <vl-layer-vector>
                <vl-source-vector
                  :features.sync="features"
                ></vl-source-vector>
              </vl-layer-vector>

            </vl-map>

          </v-flex>

          <v-flex xs3>
            <v-card>
              <v-card-text class="px-0">
                <h1>Opciones</h1>
                  <v-btn
                    color="primary"
                    @click="getAllFeatures()"
                  >
                    <v-icon left>cloud_download</v-icon>
                    Localidades
                  </v-btn>

                  <v-btn
                    color="warning"
                    @click="cleanFeatures()"
                  >
                    <v-icon left>delete_forever</v-icon>
                    Localidades
                  </v-btn>

                  <!-- map panel, controls -->
                  <div class="map-panel">
                    <div slot="trigger" class="panel-heading">
                      <div class="columns">
                        <div class="column is-11">
                          <strong>Map panel</strong>

                          <div class="panel-block">
                            <table class="table is-fullwidth">
                              <tr>
                                <th>Map center</th>
                                <td>{{ mapViewConf.center }}</td>
                              </tr>
                              <tr>
                                <th>Map zoom</th>
                                <td>{{ mapViewConf.zoom }}</td>
                              </tr>
                              <tr>
                                <th>Map rotation</th>
                                <td>{{ mapViewConf.rotation }}</td>
                              </tr>
                              <tr>
                                <th>Selected features</th>
                                <td>
                                  {{ selectedFeatures.length }}
                                  {{ selectedFeatures.map(f => f.id) }}
                                  {{ selectedFeatures.map(f => f.properties.nombre) }}
                                </td>
                              </tr>
                              <tr>
                                <th>Selected</th>
                                <td>
                                  {{ selected.length }}
                                  {{ selected.map(f => f.id) }}
                                  {{ selected.map(f => f.properties.nombre) }}
                                </td>
                              </tr>
                              <tr>
                                <th>Layers</th>
                                <td>
                                  {{ layers.length }}
                                  {{ layers.map(f => f.id) }}
                                </td>
                              </tr>
                              <tr>
                                <th>Features</th>
                                <td>
                                  {{ features.length }}
                                  {{ features.map(f => f.id) }}
                                </td>
                              </tr>
                              <tr>
                                <th>Loading</th>
                                <td>{{ loading }}</td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <p class="panel-tabs">
                      <a @click="showMapPanelTab('state')" :class="mapPanelTabClasses('state')">State</a>
                      <a @click="showMapPanelTab('layers')" :class="mapPanelTabClasses('layers')">Layers</a>
                    </p>

                    <div class="panel-block" v-show="mapPanel.tab === 'state'">
                      <table class="table is-fullwidth">
                        <tr>
                          <th>Map center</th>
                          <td>{{ center }}</td>
                        </tr>
                        <tr>
                          <th>Map zoom</th>
                          <td>{{ zoom }}</td>
                        </tr>
                        <tr>
                          <th>Map rotation</th>
                          <td>{{ rotation }}</td>
                        </tr>
                        <tr>
                          <th>Device coordinate</th>
                          <td>{{ deviceCoordinate }}</td>
                        </tr>
                        <tr>
                          <th>Selected features</th>
                          <td>{{ selectedFeatures.map(f => f.id) }}</td>
                        </tr>
                      </table>
                    </div>

                    <div class="panel-block"
                      v-for="layer in layers"
                      :key="layer.id"
                      @click="showMapPanelLayer"
                      :class="{ 'is-active': layer.visible }"
                      v-show="mapPanel.tab === 'layers'"
                    >
                      <b-switch :key="layer.id" v-model="layer.visible">
                        {{ layer.title }}
                      </b-switch>
                    </div> -->
                  </div>
                  <!--// map panel, controls -->

              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
// import { kebabCase } from 'lodash'

// import Vue from 'vue'
// import VueLayers from 'vuelayers'
// import 'vuelayers/lib/style.css' // needs css-load:querySelector('query')er

// import ScaleLine from 'ol/control/ScaleLine'

// Vue.use(VueLayers)
// Vue.use(VueLayers, {
//   dataProjection: 'EPSG:4326'
// })

export default {
  name: `Maps`,

  /*
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
  },

  data: function () {
    return {
      backConf: {
        path: '/maps/localidad/?page=',
        page: 1
      },
      mapViewConf: {
        center: [-74.08175, 4.60971],
        zoom: 12,
        minZoom: 10,
        maxZoom: 16,
        rotation: 0
      },
      // map: null,
      // tileLayer: null,
      // mark: null,
      // localidades: null,
      selectedFeatures: [],
      selected: [],
      layers: [],
      features: [],
      loading: false,
      geolocPosition: undefined,
      panelOpen: true,
      drawType: undefined
    }
  },

  methods: {
    cleanFeatures () {
      this.features = []
    },

    getAllFeatures () {
      this.loading = true
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.path + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.features = t.features.concat(resp.data.results.features)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.getAllFeatures()
          } else {
            t.backConf.page = 1
            t.loading = false
          }
        })
        .catch(err => console.error(err))
    }

    // onMapMounted () {
    //   // now ol.Map instance is ready and we can work with it directly
    //   this.$refs.map.$map.getControls().extend([
    //     new ScaleLine()
    //   ])
    // },
    //
    // onMapClick () {
    //   console.log('in click')
    //   // this.selectedFeatures = this.selectedFeatures.filter(f => f.id !== feature.id)
    //   // selFeat = this.selectedFeatures.filter(f => f.id !== feature.id)
    //   // this.selectedFeatures.push(selFeat)
    //   // console.log('on',selFeat.id)
    //   // selFeat = []
    //   // var over = (f => f.id !== feature.id)
    //   // console.log('en over', over)
    //   // this.selected = this.selected.filter(f => f.id !== feature.id)
    //   // this.selectedFeatures.concat(this.selected)
    //   // this.selectedFeatures.push('1')
    //   // console.log(this.selected.length, this.selected)
    //   // console.log(this.selected.pop())
    //   // console.log(this.selectedFeatures)
    //   console.log('out click')
    // },
    //
    // geometryTypeToCmpName (type) {
    //   return 'vl-geom-' + kebabCase(type)
    // },
    // // map panel
    // mapPanelTabClasses (tab) {
    //   return {
    //     'is-active': this.mapPanel.tab === tab
    //   }
    // },
    // showMapPanelLayer (layer) {
    //   layer.visible = !layer.visible
    // },
    // showMapPanelTab (tab) {
    //   this.mapPanel.tab = tab
    //   if (tab !== 'draw') {
    //     this.drawType = undefined
    //   }
    // }
  }
}
</script>

<style>
  /* #map {
    width: 100%;
    height: 580px;
    box-shadow: 5px 5px 5px #888;
 } */
</style>
